/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { ceilDependencies } from './dependenciesCeil.generated.js';
import { floorDependencies } from './dependenciesFloor.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFix } from '../../factoriesAny.js';
export var fixDependencies = {
  ComplexDependencies,
  ceilDependencies,
  floorDependencies,
  matrixDependencies,
  typedDependencies,
  createFix
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesFix.generated.js
// module id = null
// module chunks = 